import state from './moduleVoyagePlanState.js'
import mutations from './moduleVoyagePlanMutations.js'
import actions from './moduleVoyagePlanActions.js'
import getters from './moduleVoyagePlanGetters.js'

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};